var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3137 4.43163C11.3473 4.43166 11.3801 4.42177 11.4081 4.4032C11.4361 4.38463 11.4579 4.35821 11.4709 4.32726C11.484 4.29631 11.4875 4.2622 11.4812 4.22921C11.475 4.19623 11.4591 4.16584 11.4355 4.14186L8.09464 0.744699C8.0709 0.720591 8.04052 0.704094 8.00737 0.697309C7.97422 0.690525 7.9398 0.69376 7.9085 0.706601C7.87719 0.719443 7.85042 0.74131 7.83158 0.76942C7.81275 0.797529 7.80271 0.830607 7.80273 0.864443V3.92027C7.80273 4.05589 7.85661 4.18596 7.95251 4.28186C8.04841 4.37776 8.17848 4.43163 8.3141 4.43163H11.3137Z",
    fill: "#18A0FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99396 5.24148C6.81893 5.0688 6.67986 4.86315 6.58477 4.63641C6.48969 4.40966 6.44048 4.16633 6.43999 3.92045V0H3.3718C2.64914 0.0021359 1.95669 0.290159 1.44569 0.80116C0.93469 1.31216 0.646667 2.00461 0.644531 2.72727V12.2727C0.644531 12.996 0.931868 13.6897 1.44333 14.2012C1.95479 14.7127 2.64849 15 3.3718 15H9.50817C10.2315 15 10.9252 14.7127 11.4366 14.2012C11.9481 13.6897 12.2354 12.996 12.2354 12.2727V5.79545H8.31499C8.06909 5.7951 7.82571 5.74596 7.59895 5.65086C7.37219 5.55577 7.16656 5.41662 6.99396 5.24148Z",
    fill: "#18A0FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.90fc71ff4f6bf5b1fcb8e36af7f4ba25.svg";
export { ForwardRef as ReactComponent };